<template>
  <v-form>
    <v-row>
      <v-col cols="4">
        <v-text-field name="floatAmount" type="number" outlined dense label="Amount" v-model="record.amount"></v-text-field>
      </v-col>

      <v-col cols="4">
        <span
              v-if="dateReadonly == 'Y' && role != 3"
              style="font-weight: bold; font-size: 16px"
            >Date: {{ date }}</span>
            <DatePicker v-else @date="setDate" :myDate="date" :title="`Date`" ref="dateRef"></DatePicker>
      </v-col>

      <v-col cols="12">
        <v-btn color="primary" @click="sendData">
          <v-icon left>mdi-content-save</v-icon>Save Float
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    record: {},
    dateReadonly: "N",
    date: new Date().toISOString().substr(0, 10),
    loader: false,
    categories: [
      { name: "Purchase Tax", value: "I" },
      { name: "Sales Tax", value: "O" },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.date = date;
    },
    sendData() {
      this.loader = true;
      this.record.date = this.date;
      this.record.amount = parseFloat(this.record.amount);
      this.$emit("data", this.record);
    },
  },
};
</script>